import React from 'react';
import SearchForm from './SearchForm';
import SearchResults from './SearchResults';
import defaultClasses from './storeSearch.module.css';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { Form } from 'informed';

var StoreSearch = function StoreSearch(props) {
  var classes = useStyle(defaultClasses, props.classes);
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(Form, {
    initialValues: {
      radius: props.radius
    }
  }, React.createElement(SearchForm, props)), React.createElement(SearchResults, props));
};

export default StoreSearch;